import React from 'react';
import { AvGroup } from 'availity-reactstrap-validation';
import { FormattedMessage, useIntl } from 'react-intl';
import { Label } from 'reactstrap';
import {
  getLocaleHierarchy,
  getLocalizedName,
  anyConfigRequiresAdditionMapping,
} from '../../../../utility/util/util.service';
import Select, { createFilter } from 'react-select';
import { connect } from 'react-redux';

const AdditionGroupsField = ({
  object,
  setter,
  options,
  isDisabled,
  store,
  table,
  propertyName,
  ...props
}) => {
  const intl = useIntl();
  const stringifyLocalized = (option) =>
    getLocaleHierarchy(intl.locale).reduce(
      (searchString, locale) =>
        searchString + (option.data['name' + locale] || '') + ';',
      '',
    );

  /*  const filteredOptions = options?.filter((addition) => {
    const hasPosIntegration = anyConfigRequiresAdditionMapping(store);
    const hasPosIntegrationRef =
      addition?.posIntegrationRef !== undefined &&
      addition?.posIntegrationRef !== null;

    // If store has posIntegration and the addition has a valid posIntegrationRef, keep it.
    return !hasPosIntegration || hasPosIntegrationRef;
  }); */
  return (
    <AvGroup
      className="react-select form-label-group"
      data-testid="additionGroup"
    >
      <Select
        id={object?.id}
        isMulti={true}
        isDisabled={isDisabled}
        delimiter=";"
        name="additionGroups"
        noOptionsMessage={() =>
          intl.formatMessage({ id: 'noAdditionsAvailableToSelect' })
        }
        className={'react-select-container'}
        classNamePrefix={'react-select'}
        value={
          object?.additionGroups ||
          object?.groupEntries?.map(({ group }) => group)
        }
        getOptionLabel={(additionGroup) => {
          const name = getLocalizedName(additionGroup, intl.locale);
          return name;
        }}
        getOptionValue={(additionGroup) => additionGroup.id}
        onChange={(values) => {
          if (propertyName === 'additionGroupIds') {
            setter({
              ...object,
              additionGroupIds:
                values?.map((additionGroup) => additionGroup.id) || [],
              additionGroups: values,
            });
          } else {
            setter({
              ...object,
              groupIds: values?.map((additionGroup) => additionGroup.id) || [],
              groupEntries: values?.map((group) => {
                return { group };
              }),
            });
          }
        }}
        filterOption={createFilter({ stringify: stringifyLocalized })}
        placeholder={intl.formatMessage({ id: 'itemAdditionGroupLabel' })}
        options={options}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({ ...base, zIndex: 9999 }),
        }}
        {...props}
      />
      <Label className="floating-label" for={object?.id}>
        <FormattedMessage id="itemAdditionGroupLabel" />
      </Label>
    </AvGroup>
  );
};

const mapStateToProps = (state) => ({
  table: state.store.table,
});

export default connect(mapStateToProps, {})(AdditionGroupsField);
